import styled from 'styled-components';
import { HeadlineOne } from 'components/atoms/SectionWrapper.style';

export const Offer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EditHeadlineOne = styled(HeadlineOne)`
  text-align: center;
`;
